/**
 * Wrapper for the admin route tree — system administration only (users,
 * roles, tools, queues, audit). Daily team operations live under /team
 * (`pages/team/TeamLayout.tsx`). The admin-only gate is `AdminGate`.
 */
import { Outlet } from "react-router-dom";

import { AdminGate } from "../../components/AdminGate";
import { SubNav, type SubNavItem } from "../../components/SubNav";

const ADMIN_NAV: SubNavItem[] = [
  { to: "users", label: "Users" },
  { to: "roles", label: "Roles" },
  { to: "tools", label: "Tools" },
  { to: "cron-jobs", label: "Cron jobs" },
  { to: "scopes", label: "Scopes" },
  { to: "confirmations", label: "Confirmations" },
  { to: "sessions", label: "Sessions" },
  { to: "audit", label: "Audit" },
  { to: "denials", label: "Denials" },
  { to: "health", label: "Health" },
];

export function AdminLayout() {
  return (
    <AdminGate>
      <div className="page">
        <SubNav items={ADMIN_NAV} ariaLabel="Admin sections" />
        <Outlet />
      </div>
    </AdminGate>
  );
}
